/**
 * @fileoverview Barrel exports for the extract-world-elements-v3 COMPOSITE agent.
 *
 * This composite orchestrates:
 * - world-element-core-detector-v3 (parallel, surface-level detection)
 * - world-element-rare-detector-v3 (parallel, inferential detection)
 * - world-element-detailer-v3 (sequential, description enrichment)
 *
 * Structure:
 * - definition.ts: Agent metadata with composite configuration
 * - schema.ts: Input/output Zod schemas
 * - prompt.ts: Placeholder prompt (primitives have their own prompts)
 * - flow.ts: Orchestration logic (parallel detection → merge/dedup → detailer)
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow, extractWorldElementsV3AgentFlow } from './flow';

